
export enum CountryId {
  SG = 1,
  UK = 183,
  NZ = 184
}

/**
 * Returns the country iso 2 code from Country Subdivision Code (eg. GB-SCT)
 * @param {string} code
 * @returns {string}
 */
function splitCountrySubdivisionCode(code: string): {countryCode: string, subdivisionCode: string} {
  //eg. GB-SCT
  const [countryCode, subdivisionCode] = code.split("-");
  return { countryCode, subdivisionCode };
}

/**
 * Returns the country iso 2 code from Country Subdivision Code (eg. GB-SCT)
 * @param {string} countrySubdivisionCode
 * @returns {string}
 */
export function getCountryIso2(countrySubdivisionCode: string): string {
  //eg. GB-SCT => GB
  const { countryCode } = splitCountrySubdivisionCode(countrySubdivisionCode);

  return countryCode;
}